import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import EditItemModal from '../../../Modals/HomepageHeroItem/EditItemModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllHomepageItemsTable extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            itemInEdit: null,
            itemInEditIndex: -1,
        };
    }

    updateItem =( index, id, data ) => {
        this.props.updateItem( id, data )
        .then( ( item ) => {
            return this.props.onItemUpdated && this.props.onItemUpdated( index, item );
        } );
    }

    openEditModal = ( index, user ) => {
        this.setState( { itemInEdit: user, itemInEditIndex: index } );
    }

    onEditSubmit = ( item ) => {
        var index = this.state.itemInEditIndex;
        this.props.onItemUpdated( index, item );
        this.setState( { itemInEdit: null, itemInEditIndex: -1 } );
    }

    onEditClose = () => {
        this.setState( { itemInEdit: null, itemInEditIndex: -1 } );
    }

    render() {
        const { items } = this.props;
        return (
            <div>
                <InfiniteTable
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    { this.arrayTableRows( items ) }
                </InfiniteTable>
                { this.state.itemInEdit &&
                    <EditItemModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    item={ this.state.itemInEdit } />
                }
            </div>
        );
    }

    arrayTableRows = ( items ) => {
        var rows = items.map( ( item, index ) => {
            return (
                <InfiniteTable.Row key={ item.id } className='dl-table-body'>
                    <InfiniteTable.Cell>
                        <TextTruncate text={ item.title }
                        line={ 2 } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        { item.subtitle }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        { item.type }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, item );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );
        const currentSort = this.props.currentSort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        };
        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell>
                    TITLE { sortIcon( 'title,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    SUBTITLE { sortIcon( 'subtitle,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    TYPE { sortIcon( 'type,title,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}
AllHomepageItemsTable.defaultProps = {
    onItemUpdated: ()=>{},
};

const mapDispatchToProps = () => {
    return {
        updateItem: ( id, data ) => {
            return dAPI.patch( `/admin/homepage/hero/${ id }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllHomepageItemsTable );
